export default __webpack_public_path__ + "static/media/S-041.5bdcf6d1.png";